import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelDynamic as _vModelDynamic, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "pwa-signup-page" }
const _hoisted_2 = { class: "signup-container" }
const _hoisted_3 = { class: "signup-header" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "form-content" }
const _hoisted_6 = { class: "form-field" }
const _hoisted_7 = { class: "input-with-button" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 1,
  class: "message error"
}
const _hoisted_12 = { class: "form-field" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "form-field" }
const _hoisted_15 = { class: "input-with-icon" }
const _hoisted_16 = ["type", "disabled"]
const _hoisted_17 = { class: "form-field" }
const _hoisted_18 = { class: "input-with-icon" }
const _hoisted_19 = ["type", "disabled"]
const _hoisted_20 = {
  key: 0,
  class: "message error"
}
const _hoisted_21 = {
  key: 1,
  class: "message success"
}
const _hoisted_22 = { class: "terms-section" }
const _hoisted_23 = { class: "terms-label" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "terms-text" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  class: "loading-text"
}

import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';

interface SignupData {
  m_id: string;
  m_pw: string;
  confirmPw: string;
  m_longterm_code: string;
  m_role: string;
  m_status: string;
  m_isuse: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PwaSignup',
  setup(__props) {

const router = useRouter();

const signupData = ref<SignupData>({
  m_id: '',
  m_pw: '',
  confirmPw: '',
  m_longterm_code: '',
  m_role: 'user',
  m_status: 'req',
  m_isuse: 'N',
});

const agreeTerms = ref(false);
const loading = ref(false);
const isSubmitting = ref(false);
const signupForm = ref();
const showPassword = ref(false);
const showConfirmPassword = ref(false);
const snackbar = ref({ show: false, message: '', color: 'info' });
const showTermsModal = ref(false);
const showPrivacyModal = ref(false);
const checkingId = ref(false);
const idCheckMessage = ref('');
const idCheckStatus = ref('');
const isIdAvailable = ref(false);

const isFormValid = computed(() => {
  const d = signupData.value;
  // 아이디 중복 확인, 비밀번호 일치, 약관 동의만 확인
  return isIdAvailable.value && 
         d.m_pw && 
         d.confirmPw && 
         d.m_pw === d.confirmPw && 
         agreeTerms.value;
});

const handleSignup = async () => {
  if (!isFormValid.value) {
    if (!isIdAvailable.value) {
      snackbar.value.message = '아이디 중복확인이 필요합니다.';
      snackbar.value.color = 'error';
      snackbar.value.show = true;
      return;
    }
    if (!signupData.value.m_pw || !signupData.value.confirmPw) {
      snackbar.value.message = '비밀번호를 입력해주세요.';
      snackbar.value.color = 'error';
      snackbar.value.show = true;
      return;
    }
    if (signupData.value.m_pw !== signupData.value.confirmPw) {
      snackbar.value.message = '비밀번호가 일치하지 않습니다.';
      snackbar.value.color = 'error';
      snackbar.value.show = true;
      return;
    }
    if (!agreeTerms.value) {
      snackbar.value.message = '이용약관에 동의해주세요.';
      snackbar.value.color = 'error';
      snackbar.value.show = true;
      return;
    }
    return;
  }
  if (isSubmitting.value) return;
  
  isSubmitting.value = true;
  loading.value = true;
  
  try {
    const { confirmPw, ...signupFormData } = signupData.value;
    
    const response = await fetch('/api/auth/signup', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ form: signupFormData }),
    });
    
    const result = await response.json();
    
    if (result.success) {
      snackbar.value.message = '회원가입이 완료되었습니다.';
      snackbar.value.color = 'success';
      snackbar.value.show = true;
      setTimeout(() => router.push('/pwa/login'), 800);
    } else {
      snackbar.value.message = result.message || '회원가입에 실패했습니다.';
      snackbar.value.color = 'error';
      snackbar.value.show = true;
    }
  } catch (error) {
    console.error('회원가입 오류:', error);
    snackbar.value.message = '회원가입 중 오류가 발생했습니다.';
    snackbar.value.color = 'error';
    snackbar.value.show = true;
  } finally {
    loading.value = false;
    isSubmitting.value = false;
  }
};

const goToLogin = () => {
  router.push('/pwa/login');
};

const onIdInput = () => {
  idCheckMessage.value = '';
  idCheckStatus.value = '';
  isIdAvailable.value = false;
};

const checkIdDuplicate = async () => {
  if (!signupData.value.m_id || signupData.value.m_id.length < 6) {
    idCheckMessage.value = '6자 이상 입력해주세요.';
    idCheckStatus.value = 'error';
    return;
  }

  checkingId.value = true;
  idCheckMessage.value = '';
  idCheckStatus.value = '';

  try {
    const response = await fetch(`/api/auth/memberIdCheck/${signupData.value.m_id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const result = await response.json();

    if (result.success) {
      idCheckMessage.value = '이미 사용 중인 아이디입니다.';
      idCheckStatus.value = 'error';
      isIdAvailable.value = false;
    } else {
      idCheckMessage.value = '사용 가능한 아이디입니다.';
      idCheckStatus.value = 'success';
      isIdAvailable.value = true;
    }
  } catch (error) {
    console.error('아이디 중복확인 오류:', error);
    idCheckMessage.value = '중복확인 중 오류가 발생했습니다.';
    idCheckStatus.value = 'error';
    isIdAvailable.value = false;
  } finally {
    checkingId.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "back-button",
          onClick: goToLogin,
          disabled: loading.value
        }, [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createTextVNode("mdi-arrow-left", -1)
            ]))]),
            _: 1
          })
        ], 8, _hoisted_4),
        _cache[15] || (_cache[15] = _createElementVNode("h1", { class: "signup-title" }, "회원가입", -1)),
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "header-spacer" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_form, {
          ref_key: "signupForm",
          ref: signupForm,
          onSubmit: _withModifiers(handleSignup, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "field-label" }, "아이디 *", -1)),
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((signupData.value.m_id) = $event)),
                  type: "text",
                  class: "form-input",
                  placeholder: "6자 이상 입력하세요",
                  disabled: loading.value || checkingId.value,
                  maxlength: "20",
                  autocomplete: "username",
                  onInput: onIdInput
                }, null, 40, _hoisted_8), [
                  [_vModelText, signupData.value.m_id]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "check-button",
                  disabled: !signupData.value.m_id || signupData.value.m_id.length < 6 || loading.value || checkingId.value,
                  onClick: checkIdDuplicate
                }, [
                  (checkingId.value)
                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                        key: 0,
                        indeterminate: "",
                        size: "16",
                        width: "2",
                        color: "white"
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10, "중복확인"))
                ], 8, _hoisted_9)
              ]),
              (idCheckMessage.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(['message', idCheckStatus.value])
                  }, _toDisplayString(idCheckMessage.value), 3))
                : _createCommentVNode("", true),
              (!idCheckMessage.value && signupData.value.m_id && signupData.value.m_id.length < 6)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 6자 이상 입력해주세요. "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "field-label" }, "장기요양기관기호 *", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((signupData.value.m_longterm_code) = $event)),
                type: "text",
                class: "form-input",
                placeholder: "장기요양기관기호를 입력하세요",
                disabled: loading.value,
                autocomplete: "off",
                maxlength: "15"
              }, null, 8, _hoisted_13), [
                [_vModelText, signupData.value.m_longterm_code]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[19] || (_cache[19] = _createElementVNode("label", { class: "field-label" }, "비밀번호 *", -1)),
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((signupData.value.m_pw) = $event)),
                  type: showPassword.value ? 'text' : 'password',
                  class: "form-input",
                  placeholder: "비밀번호를 입력하세요",
                  disabled: loading.value,
                  autocomplete: "new-password",
                  maxlength: "50"
                }, null, 8, _hoisted_16), [
                  [_vModelDynamic, signupData.value.m_pw]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "icon-button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (showPassword.value = !showPassword.value))
                }, [
                  _createVNode(_component_v_icon, { size: "20" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(showPassword.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[20] || (_cache[20] = _createElementVNode("label", { class: "field-label" }, "비밀번호 확인 *", -1)),
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((signupData.value.confirmPw) = $event)),
                  type: showConfirmPassword.value ? 'text' : 'password',
                  class: "form-input",
                  placeholder: "비밀번호를 다시 입력하세요",
                  disabled: loading.value,
                  autocomplete: "new-password",
                  maxlength: "50"
                }, null, 8, _hoisted_19), [
                  [_vModelDynamic, signupData.value.confirmPw]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "icon-button",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (showConfirmPassword.value = !showConfirmPassword.value))
                }, [
                  _createVNode(_component_v_icon, { size: "20" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(showConfirmPassword.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              (signupData.value.confirmPw && signupData.value.m_pw && signupData.value.confirmPw !== signupData.value.m_pw)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, " 비밀번호가 일치하지 않습니다. "))
                : _createCommentVNode("", true),
              (signupData.value.confirmPw && signupData.value.m_pw && signupData.value.confirmPw === signupData.value.m_pw)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, " 비밀번호가 일치합니다. "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((agreeTerms).value = $event)),
                  type: "checkbox",
                  class: "terms-checkbox",
                  disabled: loading.value
                }, null, 8, _hoisted_24), [
                  [_vModelCheckbox, agreeTerms.value]
                ]),
                _createElementVNode("span", _hoisted_25, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (showTermsModal.value = true), ["prevent"])),
                    class: "terms-link"
                  }, "이용약관"),
                  _cache[21] || (_cache[21] = _createTextVNode(" 및 ", -1)),
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (showPrivacyModal.value = true), ["prevent"])),
                    class: "terms-link"
                  }, "개인정보처리방침"),
                  _cache[22] || (_cache[22] = _createTextVNode("에 동의합니다. ", -1))
                ])
              ])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["submit-button", { 'loading': loading.value }]),
              disabled: !isFormValid.value || isSubmitting.value,
              onClick: handleSignup
            }, [
              (!loading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, "회원가입"))
                : (_openBlock(), _createElementBlock("span", _hoisted_28, "처리 중..."))
            ], 10, _hoisted_26)
          ]),
          _: 1
        }, 512)
      ])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: showTermsModal.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showTermsModal).value = $event)),
      "max-width": "90%",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { rounded: "lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "modal-title" }, {
              default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                _createTextVNode("이용약관", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "modal-content" }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createElementVNode("div", { class: "terms-content" }, [
                  _createElementVNode("h3", null, "제1조 (목적)"),
                  _createElementVNode("p", null, "이 약관은 재가장기요양센터 관리 시스템(이하 \"서비스\")을 제공하는 하이파이브 주식회사(이하 \"회사\")와 이를 이용하는 회원(이하 \"이용자\") 간의 서비스 이용에 관한 제반 사항과 기타 필요한 사항을 구체적으로 규정함을 목적으로 합니다."),
                  _createElementVNode("h3", null, "제2조 (정의)"),
                  _createElementVNode("p", null, "1. \"서비스\"라 함은 재가장기요양센터의 운영 관리를 위한 웹 기반 시스템을 의미합니다."),
                  _createElementVNode("p", null, "2. \"이용자\"라 함은 이 약관에 따라 회사가 제공하는 서비스를 받는 회원을 말합니다."),
                  _createElementVNode("p", null, "3. \"회원\"이라 함은 회사에 개인정보를 제공하여 회원등록을 한 자로서, 회사의 정보를 지속적으로 제공받으며, 회사가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다."),
                  _createElementVNode("h3", null, "제3조 (약관의 효력 및 변경)"),
                  _createElementVNode("p", null, "1. 이 약관은 서비스를 신청하여 회사의 승낙을 받은 때부터 효력이 발생합니다."),
                  _createElementVNode("p", null, "2. 회사는 약관을 변경하는 경우 변경사유 및 적용일자를 명시하여 현행약관과 함께 서비스 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다."),
                  _createElementVNode("p", null, "3. 회원이 변경된 약관에 동의하지 않는 경우, 회원은 서비스 이용계약을 해지할 수 있습니다.")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "modal-actions" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  block: "",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (showTermsModal.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                    _createTextVNode("닫기", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showPrivacyModal.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((showPrivacyModal).value = $event)),
      "max-width": "90%",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { rounded: "lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "modal-title" }, {
              default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                _createTextVNode("개인정보처리방침", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "modal-content" }, {
              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                _createElementVNode("div", { class: "privacy-content" }, [
                  _createElementVNode("h3", null, "1. 개인정보의 처리목적"),
                  _createElementVNode("p", null, "하이파이브 주식회사(이하 \"회사\")는 다음의 목적을 위하여 개인정보를 처리하고 있으며, 다음의 목적 이외의 용도로는 이용하지 않습니다."),
                  _createElementVNode("p", null, "- 회원 가입 및 관리"),
                  _createElementVNode("p", null, "- 재가장기요양센터 운영 관리 서비스 제공"),
                  _createElementVNode("p", null, "- 고객 상담 및 불만 처리"),
                  _createElementVNode("p", null, "- 서비스 개선 및 신규 서비스 개발"),
                  _createElementVNode("h3", null, "2. 개인정보의 처리 및 보유기간"),
                  _createElementVNode("p", null, "① 회사는 정보주체로부터 개인정보를 수집할 때 동의받은 개인정보 보유·이용기간 또는 법령에 따른 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다."),
                  _createElementVNode("p", null, "② 구체적인 개인정보 처리 및 보유 기간은 다음과 같습니다."),
                  _createElementVNode("p", null, "- 회원 가입 및 관리: 회원 탈퇴 시까지"),
                  _createElementVNode("p", null, "- 서비스 제공: 서비스 이용계약 종료 시까지"),
                  _createElementVNode("p", null, "- 고객 상담: 상담 완료 후 3년")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "modal-actions" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  block: "",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (showPrivacyModal.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                    _createTextVNode("닫기", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: snackbar.value.show,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((snackbar.value.show) = $event)),
      color: snackbar.value.color,
      timeout: "2500",
      rounded: "lg",
      location: "top"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackbar.value.message), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color"])
  ]))
}
}

})